import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import Colors from '../../../assets/Colors';
import CloseIcon from '../../icons/CloseIcon';
import s from '../../../styles/Header.styles';

function FormHeaderWithTab({
  closeModal,
  onSave,
  updating,
  section,
  setSection,
  enabled,
  saving,
  addTitle,
  updateTitle,
  tabs,
}) {
  const { t } = useTranslation();

  return (
    <s.Header>
      <s.HeaderTopItems>
        <s.IconContainer onClick={() => closeModal()}>
          <CloseIcon size={13} color={Colors.primary} />
        </s.IconContainer>
        <s.TitleContainer>{updating ? updateTitle : addTitle}</s.TitleContainer>
        <Button
          loading={saving}
          style={{
            fontSize: '15px',
            fontWeight: '500',
          }}
          type="text"
          onClick={enabled ? onSave : undefined}
          disabled={!enabled}
        >
          {t('components.CustomerList.AddCustomer.Header.save')}
        </Button>
      </s.HeaderTopItems>

      <s.HeaderSecondLineContainer>
        {tabs.map((tap) => (
          <s.MenuTitleContainer
            style={{
              marginRight: '37px',
              textAlign: 'center',
            }}
            selected={section === tap.id}
            onClick={() => setSection(tap.id)}
            key={tap.id}
          >
            {tap.name}
          </s.MenuTitleContainer>
        ))}
      </s.HeaderSecondLineContainer>
    </s.Header>
  );
}

export default FormHeaderWithTab;
